(function() { window.GUID_b593ac49_9be3_43a8_8f3b_32427d2a3adc = { getGuid: function() { return "b593ac49-9be3-43a8-8f3b-32427d2a3adc"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class FloatingSpares {
                        static RefreshSection() {
                            let accordion = CS.Controls.GetInstance(CS.Controls.Accordion, '.accordion-floatingspares', true);
                            if (accordion != null) {
                                accordion.RefreshContent();
                            }
                        }
                    }
                    WallSections.FloatingSpares = FloatingSpares;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=floating-spares.js.map
